module.exports = __webpack_public_path__ + "static/AW_happy-cb7f7f21bb6936dc86861ea36a9b1c20.jpg";